// @ts-nocheck
import { TENANT_COM } from 'shared/consts'
import logger from 'shared/services/logger'
import { Tenant } from 'types/shopConfig'

import { REDIRECTION_TENANTS } from './consts'

type GeoData = {
  country: Tenant
}

/**
 * A helper class that fetches geo data of the customer using their IP.
 *
 * If URL contains `__debugCustomerCountry` param,
 * it is used for displaying the tenant-specific param
 *
 * The geo-localization endpoint is a Google Cloud function.
 * @url https://github.com/RedTecLab/cloud_function_geo_localization
 */
class GeoFetcher {
  static URL_DEV = 'https://sls.ref-sa-tech.io/geo-localization'
  static URL_PROD = 'https://sls.sa-tech.de/geo-localization'
  static URL_DEBUG_PARAM = '__debugCustomerCountry'

  private readonly url: string

  constructor(private readonly environment: string = '') {
    this.url = this.getUrl()
  }

  getUrl(): string {
    return ['test', 'development'].includes(this.environment)
      ? GeoFetcher.URL_DEV
      : GeoFetcher.URL_PROD
  }

  async fetch(): Promise<GeoData> {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const customerCountry = <Tenant>urlParams.get(GeoFetcher.URL_DEBUG_PARAM)

    if (REDIRECTION_TENANTS.concat(TENANT_COM).includes(customerCountry)) {
      return {
        country: customerCountry,
      }
    }

    let data
    try {
      const response = await fetch(this.url)
      data = await response.json()
    } catch (error) {
      logger.error('Cannot fetch Geo Data', { error })
    }

    return {
      country: (data?.country || TENANT_COM).toLowerCase(),
    }
  }
}

export default GeoFetcher
